import ReactModal from 'react-modal';
import { ICustomModal } from 'interfaces/components/customModal';

const CustomModal = ({
  isOpen,
  onClose,
  className,
  children
}: ICustomModal) => {
  return (
    <ReactModal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldFocusAfterRender={false}
      overlayClassName='fixed inset-0 bg-black/50 dark:bg-white/50 z-[100] flex justify-center items-center'
      className={`absolute bg-white dark:bg-black dark:text-white ${className}`}
    >
      {children}
    </ReactModal>
  );
};

export default CustomModal;
